<template>
  <div class="root" v-if="isLoggedIn">
    <font-awesome-icon :id="randomId" class="report-button" icon="ellipsis-v" full-width/>
    <b-popover :target="randomId" triggers="click blur" placement="bottomleft" title="" ref="popover">
      <div class="actions">
        <slot></slot>
        <LinkButton @click="showReportDialog = true">{{ label || 'Report' }}</LinkButton>
      </div>
      <div :class="reportClass" v-if="showReportDialog">
        <b-form-group>
          <b-form-select v-model="reason" :options="reasonOptions" size="sm" />
        </b-form-group>

        <b-button class="btn-rainbow" @click="send" :disabled="!sendEnabled">
          report
        </b-button>
        <font-awesome-icon icon="spinner" size="lg" spin v-if="working" />
        <LinkButton :u="true" class="ml-2" @click="close">cancel</LinkButton>
      </div>
    </b-popover>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .root {
    display: inline-block;
  }

  .actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 12em;
  }

  .report-button {
    display: inline-block;
    cursor: pointer;
  }

  .report-popover {

    img {
      width: 1.2em;
      margin-right: 0.5em;
    }

    .amount {
      width: 5em;
      font-size: 0.8em;
    }

    &.divider {
      margin-top: 0.5em;
      padding-top: 0.5em;
      border-top: 1px solid $steel;
    }
  }

</style>

<script>
import { mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import LinkButton from '@/components/widgets/LinkButton'

import { reportReasons } from '@/store/modules/tag'

export default {
  name: 'Report',
  components: {
    FontAwesomeIcon,
    LinkButton
  },
  props: {
    artist: Object,
    profile: Object,
    update: Object,
    live: Object,
    video: Object,
    comment: Object,
    label: String
  },
  data () {
    return {
      randomId: 'reportButton-' + (+new Date()) + ':' + Math.round(1000000 * Math.random()),
      working: false,
      reason: null,
      showReportDialog: false
    }
  },
  computed: {
    reasonOptions () {
      return reportReasons
    },
    sendEnabled () {
      return !!this.reason
    },
    reportClass () {
      let cls = ['report-popover']
      if (this.$slots.default) cls.push('divider')
      return cls
    },
    ...mapGetters('auth', ['isLoggedIn'])
  },
  methods: {
    async send () {
      if (!this.sendEnabled) return

      let type = null
      let id = null

      if (this.comment) {
        if (this.update) {
          type = 'feed/reportUpdateComment'
          id = this.update.id
        } else if (this.video) {
          type = 'song/reportSongComment'
          id = this.video.id
        } else if (this.live) {
          type = 'live/reportLiveEventComment'
          id = this.live.id
        }
      } else {
        if (this.profile) {
          type = 'profile/reportProfile'
          id = this.profile.id
        } else if (this.artist) {
          type = 'artist/reportArtist'
          id = this.artist.id
        } else if (this.update) {
          type = 'feed/reportUpdate'
          id = this.update.id
        } else if (this.video) {
          type = 'song/reportSong'
          id = this.video.id
        } else if (this.live) {
          type = 'live/reportLiveEvent'
          id = this.live.id
        }
      }

      if (!type) {
        console.log('[report] nothing to report')
        this.close()
        return
      }

      let data = {
        reason: this.reason,
        url: this.$route.fullPath
      }

      if (this.comment) {
        data.subjectId = id
        data.commentId = this.comment.id
      } else {
        data.id = id
      }

      this.working = true
      await this.$store.dispatch(type, data)
      this.working = false

      this.$store.dispatch('flash/showMessage', {message: 'Thank you for reporting this'})
      this.close()
    },
    open () {
      this.$refs.popover.$emit('open')
    },
    close () {
      this.showReportDialog = false
      this.working = false
      this.reason = null
      this.$refs.popover.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Report.vue